export const ADD_NEW_CONNECTION_MODAL_KEY = 'workflows-add-new-connection'
